export function showHelp() {
	$('.help-bar').toggle()
}
